<div [ngStyle]="{ height: height, width: width, 'border-radius': borderRadius }">
  <ngx-skeleton-loader
    [ngStyle]="{ display: isLoading ? 'block' : 'none' }"
    [theme]="{ height: height, width: width, margin: '0' }"
    [appearance]="skeletonAppearance"
  ></ngx-skeleton-loader>
  <img
    [ngStyle]="{ opacity: isLoading ? '0' : '1', height: '100%', width: '100%', 'border-radius': borderRadius }"
    [src]="imageUrl"
    (load)="onLoad()"
    class="object-cover"
  />
</div>
